import { computed, type Ref, ref } from 'vue'

export const useMediaRecorder = (): {
  isRecording: Readonly<Ref<boolean>>
  start: (stream: MediaStream) => void
  stop: () => Promise<Blob>
} => {
  let recorder: MediaRecorder | undefined
  const isRecording = ref(false)
  const recordedVideoBlob = ref<Blob>(new Blob())

  const start = (stream: MediaStream): void => {
    recorder = new MediaRecorder(stream, {
      mimeType: MediaRecorder.isTypeSupported('video/webm;codec=vp9')
        ? 'video/webm;codec=vp9'
        : MediaRecorder.isTypeSupported('video/mp4;codec=h264')
          ? 'video/mp4;codec=h264'
          : 'video/mp4;',
    })
    recorder.addEventListener('dataavailable', (e) => {
      recordedVideoBlob.value = e.data
    })
    recorder.start()
    isRecording.value = true
  }

  const stop = (): Promise<Blob> =>
    new Promise((resolve) => {
      if (!recorder) {
        return resolve(new Blob())
      }
      recorder.addEventListener('stop', () => {
        isRecording.value = false
        resolve(recordedVideoBlob.value)
      })
      recorder.stop()
    })
  return { isRecording: computed(() => isRecording.value), start, stop }
}
